import URL from 'url-parse'

const selector = '%%%LINK%%%'
const className = 'external-link'

export default function (input: string, fill = false) {
  if (input) {
    input += ' '
    input = input.replace(/(<([^>]+)>)/gi, '')

    // eslint-disable-next-line prefer-const
    let tail = false
    const links = input.match(
      /(https?|steam):\/\/(www\.)?[a-z0-9.:].*?(?=\s)/gi
    )
    const appendLinks: string[] = []
    if (links && links.length) {
      links.forEach(link => {
        const urlData = new URL(link)
        let fullpathname = urlData.pathname

        if (urlData.query) {
          fullpathname += urlData.query
        }

        const title = fill
          ? link
          : urlData.hostname + (tail ? getTail(fullpathname) : '')
        appendLinks.push(
          `<a class="${className}" title="${link}" href="${link}" rel="noopener" target="_blank">${title}</a>`
        )
        input = input.replace(link, selector)
      })

      appendLinks.forEach(link => {
        input = input.replace(selector, link)
      })
    }

    input = input.slice(0, -1)
  }

  return input
}

function getTail(str = '', max = 15) {
  if (str.length < max) {
    return str
  }

  const offset = Math.floor((max - 3) / 2)
  return str.substr(0, offset) + '...' + str.substr(-offset)
}
